var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnlineLogoColor = function SvgOnlineLogoColor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 175 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Online-Logo-Color_svg__Online-Logo-Color 1",
    clipPath: "url(#Online-Logo-Color_svg__clip0_8_3783)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Online-Logo-Color_svg__Layer 1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Online-Logo-Color_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Online-Logo-Color_svg__Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector",
    fill: "#1B365D",
    d: "m48.098 25.663-.898-2.877h-5.942l-.948 2.877h-4.964l7.028-19.321h3.661l7.028 19.321zm-3.77-11.997-1.737 5.157h3.365z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_2",
    fill: "#1B365D",
    d: "M64.276 23.956c-.869.922-2.334 1.87-4.693 1.87-2.36 0-3.825-.948-4.694-1.87-1.219-1.328-1.604-2.715-1.604-5.592s.38-4.26 1.604-5.592c.869-.923 2.334-1.87 4.694-1.87 2.358 0 3.824.947 4.693 1.87 1.219 1.328 1.599 2.74 1.599 5.592s-.38 4.259-1.6 5.592m-3.5-8.632c-.27-.272-.65-.41-1.194-.41-.542 0-.922.138-1.194.41-.572.567-.651 1.599-.651 3.04s.084 2.467.651 3.04c.272.271.652.405 1.195.405.542 0 .922-.134 1.194-.405.572-.567.651-1.599.651-3.04s-.084-2.468-.651-3.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_3",
    fill: "#1B365D",
    d: "M75.622 18.769H72.72v6.894h-4.747V6.342h7.654c4.289 0 6.594 3.04 6.594 6.213s-2.305 6.214-6.594 6.214zm-.217-8.168H72.72v3.909h2.685c1.303 0 2.063-.948 2.063-1.955 0-1.006-.76-1.954-2.063-1.954"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_4",
    fill: "#1B365D",
    d: "M90.141 25.826c-2.956 0-5.374-.543-7.329-2.552l3.04-3.04c1.002 1.002 2.77 1.358 4.314 1.358 1.87 0 2.769-.622 2.769-1.738 0-.459-.109-.839-.38-1.14-.247-.246-.652-.434-1.274-.513l-2.334-.326c-1.708-.246-3.01-.814-3.88-1.707-.892-.923-1.327-2.226-1.327-3.88 0-3.528 2.66-6.104 7.058-6.104 2.768 0 4.856.651 6.514 2.305l-2.986 2.985c-1.219-1.219-2.823-1.14-3.662-1.14-1.653 0-2.334.948-2.334 1.792 0 .247.084.597.38.893.247.242.652.489 1.333.568l2.334.325c1.737.247 2.986.79 3.8 1.6 1.031 1.001 1.441 2.442 1.441 4.234 0 3.933-3.39 6.08-7.462 6.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_5",
    fill: "#009FAD",
    d: "M114.679 23.763c-1.332 1.328-3.04 2.063-5.103 2.063s-3.746-.73-5.073-2.063c-1.9-1.9-1.871-4.042-1.871-7.763s-.024-5.863 1.871-7.763c1.332-1.328 3.01-2.063 5.073-2.063s3.771.73 5.103 2.063c1.9 1.9 1.846 4.042 1.846 7.763s.054 5.863-1.846 7.763m-2.226-13.76c-.681-.73-1.737-1.194-2.877-1.194s-2.196.46-2.877 1.195c-.948 1.031-1.14 2.117-1.14 5.996s.187 4.965 1.14 5.996c.681.73 1.737 1.195 2.877 1.195s2.196-.464 2.877-1.195c.948-1.031 1.14-2.117 1.14-5.996s-.187-4.965-1.14-5.996"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_6",
    fill: "#009FAD",
    d: "M128.251 25.663v-8.385c0-2.142-1.219-3.065-2.768-3.065-1.55 0-2.848.948-2.848 3.065v8.385h-2.769v-13.76h2.715v1.383c.947-1.032 2.28-1.545 3.662-1.545 1.381 0 2.576.464 3.39 1.249 1.056 1.03 1.382 2.334 1.382 3.879v8.794h-2.769z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_7",
    fill: "#009FAD",
    d: "M138.294 25.663c-2.63 0-3.77-1.762-3.77-3.8V6.342h2.769v15.363c0 1.056.38 1.6 1.49 1.6h1.219v2.358z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_8",
    fill: "#009FAD",
    d: "M142.282 9.19V6.257h2.932v2.931zm.084 16.473v-13.76h2.769v13.76z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_9",
    fill: "#009FAD",
    d: "M157.241 25.663v-8.385c0-2.142-1.219-3.065-2.769-3.065-1.549 0-2.847.948-2.847 3.065v8.385h-2.769v-13.76h2.714v1.383c.948-1.032 2.28-1.545 3.662-1.545s2.576.464 3.391 1.249c1.056 1.03 1.382 2.334 1.382 3.879v8.794h-2.769z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_10",
    fill: "#009FAD",
    d: "M165.626 19.583c0 2.359 1.248 3.854 3.499 3.854 1.545 0 2.359-.434 3.336-1.411l1.767 1.653c-1.412 1.412-2.739 2.142-5.157 2.142-3.445 0-6.189-1.816-6.189-7.057 0-4.452 2.305-7.028 5.833-7.028s5.834 2.714 5.834 6.623v1.219h-8.928.005zm5.809-3.8c-.435-1.032-1.412-1.737-2.715-1.737s-2.305.705-2.739 1.737c-.271.627-.326 1.031-.35 1.87h6.189c-.025-.844-.109-1.248-.38-1.87z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Online-Logo-Color_svg__Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_11",
    fill: "#009FAD",
    d: "m15.19.074-4.096 2.32 4.096 2.368 4.047-2.368z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_12",
    fill: "#009FAD",
    d: "m14.499 5.108-4.047-2.32-4.047 2.32 4.047 2.369z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_13",
    fill: "#009FAD",
    d: "m19.879 7.477 4.047-2.37-4.047-2.319-4.047 2.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_14",
    fill: "#009FAD",
    d: "M24.616 5.503 20.52 7.872l4.096 2.32 4.047-2.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_15",
    fill: "#009FAD",
    d: "M5.714 5.503 1.667 7.872l4.047 2.32 4.097-2.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_16",
    fill: "#1B365D",
    d: "m5.418 21.641-4.046-2.32v4.689l4.046 2.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_17",
    fill: "#1B365D",
    d: "m10.107 24.355-4.047-2.32v4.69l4.047 2.368z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_18",
    fill: "#1B365D",
    d: "m5.418 16.212-4.046-2.369v4.689L5.418 20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_19",
    fill: "#1B365D",
    d: "m5.418 10.784-4.046-2.37v4.689l4.046 2.369z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_20",
    fill: "#1B365D",
    d: "m14.845 27.119-4.047-2.369v4.689l4.047 2.369z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_21",
    fill: "#D1D3D4",
    d: "m24.913 26.33 4.096-2.32v-4.69l-4.096 2.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_22",
    fill: "#D1D3D4",
    d: "m20.224 29.093 4.047-2.369v-4.688l-4.047 2.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_23",
    fill: "#D1D3D4",
    d: "m24.913 20.9 4.096-2.368v-4.689l-4.096 2.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_24",
    fill: "#D1D3D4",
    d: "m29.009 8.415-4.096 2.369v4.688l4.096-2.369z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_25",
    fill: "#D1D3D4",
    d: "m15.486 31.808 4.047-2.37V24.75l-4.047 2.369z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_26",
    fill: "#009FAD",
    d: "m15.19 21.838-4.096 2.37 4.096 2.319 4.047-2.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_27",
    fill: "#009FAD",
    d: "m19.879 19.124-4.047 2.369 4.047 2.32 4.047-2.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_28",
    fill: "#009FAD",
    d: "m10.452 19.124-4.047 2.369 4.047 2.32 4.047-2.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_29",
    fill: "#1B365D",
    d: "m24.271 10.784-4.047-2.37v4.689l4.047 2.369z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_30",
    fill: "#1B365D",
    d: "M19.533 8.02 15.486 5.7v4.689l4.047 2.368z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_31",
    fill: "#1B365D",
    d: "m24.271 16.212-4.047-2.369v4.689l4.047 2.369z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_32",
    fill: "#D1D3D4",
    d: "M10.107 8.415 6.06 10.784v4.688l4.047-2.369z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_33",
    fill: "#D1D3D4",
    d: "m14.845 5.7-4.047 2.32v4.737l4.047-2.368z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_34",
    fill: "#D1D3D4",
    d: "m6.06 20.9 4.047-2.368v-4.689l-4.047 2.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_35",
    fill: "#D1D3D4",
    d: "m19.533 13.843-4.047 2.37V20.9l4.047-2.37z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_36",
    fill: "#1B365D",
    d: "m10.798 18.532 4.047 2.369v-4.689l-4.047-2.369z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Online-Logo-Color_svg__Vector_37",
    fill: "#009FAD",
    d: "M15.19 10.932 11.094 13.3l4.096 2.37 4.047-2.37z"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Online-Logo-Color_svg__clip0_8_3783"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.784 0h173.774v32H.784z"
  })))));
};
export default SvgOnlineLogoColor;